import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mainSelector", "receiver"]

  setOptions() {
    const mainSelectorItems = this.getMainSelectorOpts()

    this.removeReceiverSelectedOpts(mainSelectorItems)
    this.setReceiverOpts(mainSelectorItems)
  }

  getMainSelectorOpts() {
    return this.mainSelectorTarget.tomselect.items
  }

  setReceiverOpts(mainSelectorOptions) {
    this.receiverTarget.tomselect.clearOptions()

    mainSelectorOptions.forEach(mainSelectorValue => {
      const mainSelectorOptionText = this.mainSelectorTarget.tomselect.options[mainSelectorValue].text
      this.receiverTarget.tomselect.addOption({value: mainSelectorValue, text: mainSelectorOptionText})
    })
  }

  removeReceiverSelectedOpts(mainSelectorOptions) {
    if (mainSelectorOptions.includes(this.receiverTarget.tomselect.items[0])) { return }

    this.receiverTarget.tomselect.removeItem(this.receiverTarget.tomselect.items[0])
  }
}
